module.exports = {
	"dashboard": {
		"partnerBanner": {
			"title": "Din særlige pakkeløsning",
			"text": "Som {partnerName} kunde får du en hel særlig pakke hvor kan få {purchaseType} på {numberOfDocuments} valgfrie juridiske dokumenter til {price} ud af {numberOfDocuments} juridiske dokumenter.",
			"button": "Vælg dine dokumenter",
			"addToBasketButton": "Tilføj til kurven",
			"error": "Noget gik galt. Prøv igen, eller kontakt vores support.",
			"selectPlaceholder": "Vælg dokument",
			"goToBasket": "Køb mine dokumenter"
		},
		"waitingForPaymentBanner": {
			"title": "Afventede betaling",
			"text_with_help": "Du har en ordre omhandlende {documents} til {price} som er klar til betaling.",
			"text_without_help": "Du har et møde omhandlende {documents} til {price} som er klar til betaling.",
			"cta": "Betal for din ordre"
		},
		"amount": "{amount},-",
		"purchase": "Køb",
		"upgrade": "Opgrader",
		"upgrade_to_advice": "Opgrader til fuld rådgivning",
		"booking": "Du har bestilt {time} minutter til {type} d. {date}. Sørg for at sidde klar på TestaViva når vores jurist ringer dig op.",
		"booking_completed": "Du afholdte et møde med {type} d. {date}.",
		"booking_error": "Kunne ikke gemme din booking. Prøv at vælge et andet tidspunkt, eller kontakt support på 88 62 50 60 eller support@testaviva.dk",
		"booking_occupied": "Tidspunktet er desværre netop blevet booket af en anden bruger. Prøv at vælge et andet tidspunkt.",
		"fetching_dates": "Henter mulige tidspunkter...",
		"fetching_dates_error": "Kunne ikke hente ledige tidspunkter. Prøv at genindlæse siden, eller henvend dig til vores support.",
		"documents": {
			"overview": {
				"editModal": {
					"title": "Du kan ikke redigere dokumentet",
					"content": "<p>\n    Da der er lavet manulle ændringer i dokumentet af en af vores jurister, kan du ikke længere\n    redigere det.\n    <br />\n    Hvis du ønsker at lave ændringer i dette dokument, kan du enten henvende dig direkte til den jurist\n    der har lavet ændringerne, eller kontakte TestaViva på support@testaviva.dk\n</p>\n"
				},
				"label": {
					"edit": "Redigér",
					"delete": "Slet",
					"download": "Download"
				},
				"tooltip": {
					"edit": "Tryk her for at redigere dokumentet.",
					"delete": "Tryk her for at slette dokumentet. Denne handling kan ikke fortrydes.",
					"download": "Tryk her for at hente dit dokument.",
					"new": "Tryk her for at oprette %document%, med udgangspunkt i valgene fra dette dokument.",
					"upgrade": "Tryk her for at opgrader til rådgivning."
				}
			}
		},
		"tabs": {
			"about": "Om",
			"proces": "Proces",
			"prices": "Priser",
			"booking": "Book møde"
		},
		"prices": {
			"select": "Vælg pakke",
			"package_and_price": "Pakke og pris",
			"your_package": "Din pakke"
		},
		"advice": {
			"headline": "Book telefonmøde til {type} ved at vælge tid og dato herunder.",
			"headline_has_booking": "Her kan du se din booking",
			"week": "Uge",
			"book": "Book",
			"upgrade": "Opgradér",
			"selected_week": "Uge {week} - {year}"
		},
		"purchase_types": {
			"headlines": {
				"select": "Vælg pakke",
				"upgrade": "Opgradér din pakke"
			},
			"digital_document_basis": "Selvbetjening",
			"digital_document_review": "Juridisk tjek",
			"digital_document_advice": "Udvidet rådgivning",
			"purchase": {
				"digital_document_basis": "Med TestaVivas selvbetjeningspakke har du som bruger mulighed for at oprette dine juridiske dokumenter via vores digitale platform. Du vil blive guidet gennem processen, og du styrer selv tempo og tidspunkt.",
				"digital_document_review": "Du får 15 minutters telefonisk juridsk tjek af dit dokument med en jurist, der sikrer, at alt er korrekt. Før mødet skal du have udfyldt dokumentet. Får du brug for yderligere hjælp, kan du tilkøbe en grundigere og længere personlig rådgivning.",
				"digital_document_advice": "Du modtager en personlig udvidet rådgivning af en jurist med udgangspunkt i dit juridiske dokument. Med denne pakke sikrer du dig, at dine dokumenter er tilpasset og skræddersyet din præcise livssituation og dit behov."
			},
			"upgrade": {
				"digital_document_basis": "Med TestaVivas selvbetjeningspakke har du som bruger mulighed for at oprette dine juridiske dokumenter via vores digitale platform. Du vil blive guidet gennem processen, og du styrer selv tempo og tidspunkt.",
				"digital_document_review": "Opgrader til juridisk tjek og få 15 minutters telefonisk vejledning med en jurist, der gennemgår dit dokument. Du skal have udfyldt dit dokument inden mødet.",
				"digital_document_advice": "Opgrader til udvidet rådgivning og få en personlig udvidet rådgivning af en jurist med udgangspunkt i dit juridiske dokument. Med denne opgradering sikrer du dig, at dine dokumenter er tilpasset og skræddersyet din præcise livssituation og dit behov."
			}
		}
	}
};